require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./do-oregonians-know-about-the-crime-drop.json") })
        }
      }, "path---do-oregonians-know-about-the-crime-drop");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---do-oregonians-know-about-the-crime-drop!./.cache/json/do-oregonians-know-about-the-crime-drop.json
// module id = 876
// module chunks = 231608221292675